import { render, staticRenderFns } from "./EmailDeliveryHistoryView.vue?vue&type=template&id=08eaac06"
import script from "./EmailDeliveryHistoryView.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports